import React from 'react';
import { withStyles, Tooltip } from './../../../themes/default';
import { List, ListItem, ListItemText, ListItemSecondaryAction } from './../../../themes/list';
import { Modal } from './../../../components/includes/modal';
import { Btn } from './../../../components/includes/ui';
import { asyncLocalStorage } from './../../../utilities/storage';
import { SalesforceService } from './../../../services';

const styles = theme => ({
  successDot: {
    width: theme.spacing.unit * 2,
    height: theme.spacing.unit * 2,
    borderRadius: theme.spacing.unit,
    display: 'block',
    background: theme.palette.success.main
  }
});

class Apps extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      salesforceSubmit: false,
      salesforceStatus: false,
      salesforceStatusMessage: null,
    };
  }

  componentDidMount() {

    this.handleSalesforceStatus();

  }

  /*
  ** @Service
  ** @Description: Logout
  */

  handleSalesforceStatus = () => {

    asyncLocalStorage.getItem('salesforce').then((key) => {

      if(key){
        if(key.access_token){

          this.setState({
            salesforceStatus: true,
            salesforceStatusMessage: null
          });

        }else{

          this.setState({
            salesforceStatus: false,
            salesforceStatusMessage: key.error_description
          });

        }
      }

    });

  }

  /*
  ** @Service
  ** @Description: Auth in Salesforce
  */

  handleAuthInSalesforce = () => {

    // @State
    this.setState({ salesforceSubmit: true });

    SalesforceService.auth().then((response) => {

      // @LocalStorage
      // @Description: Set auth Salesforce response
      asyncLocalStorage.setItem('salesforce', response).then((key) => {

        // @Check salesforce status
        this.handleSalesforceStatus();

        // @State
        this.setState({ salesforceSubmit: false });

      });

    }).catch((error) => {

      // @LocalStorage
      // @Description: Set auth Salesforce response
      asyncLocalStorage.setItem('salesforce', {
        status: false,
        error: error.data.error,
        error_description: error.data.error_description
      }).then(function (key) {

        // @Check salesforce status
        this.handleSalesforceStatus();

        // @State
        this.setState({ salesforceSubmit: false});

      });

    });

  }

  /*
  ** @Click
  ** @Description: Cancel modal aplicaciones conectadas
  */

  handleCloseApps = () => {
    this.props.onCancel();
  }

  render(){

    const { salesforceStatus, salesforceStatusMessage, salesforceSubmit } = this.state;
    const { open, classes } = this.props;

    return(
      <Modal
        status={ open }
        title="Aplicaciones conectadas"
        maxWidth="sm"
        handleCancel={ this.handleCloseApps }>
        <List dense>
          <ListItem disableGutters>
            <ListItemText
              primary="Salesforce"
              secondary={ salesforceStatusMessage }
            />
            <ListItemSecondaryAction>
              { salesforceStatus ? (
                <Tooltip title="Conectado">
                  <span className={ classes.successDot }></span>
                </Tooltip>
              ) : (
                <Btn color="primary" loading={ salesforceSubmit } loadingText="Conectando..." onClick={ this.handleAuthInSalesforce }>
                  Conectar
                </Btn>
              )}
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </Modal>
    )
  }


}

export default withStyles(styles)(Apps);;
